'use client';

import React from 'react';

/**
 * Root error boundary for the App Router.
 * Catches uncaught errors in the root layout / providers (Language, Style, Theme).
 * Must be dependency-free: no context hooks, no dynamic imports, no animations.
 */
export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    return (
        <html lang="en">
            <body
                style={{
                    margin: 0,
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: 'system-ui, -apple-system, sans-serif',
                    background: '#0b0f1a',
                    color: '#fff',
                    textAlign: 'center',
                    padding: 24,
                }}
            >
                <div>
                    <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Something went wrong</h1>
                    <p style={{ opacity: 0.7, marginBottom: '1.5rem' }}>
                        We hit an unexpected error. Please try again or return to the homepage.
                    </p>
                    <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                        <button
                            onClick={reset}
                            style={{
                                padding: '10px 18px',
                                borderRadius: 8,
                                border: 'none',
                                background: '#D6213B',
                                color: '#fff',
                                fontWeight: 700,
                                cursor: 'pointer',
                            }}
                        >
                            Try again
                        </button>
                        <a
                            href="/"
                            style={{
                                padding: '10px 18px',
                                borderRadius: 8,
                                border: '1px solid rgba(255,255,255,0.25)',
                                color: '#fff',
                                textDecoration: 'none',
                                fontWeight: 700,
                            }}
                        >
                            Go home
                        </a>
                    </div>
                    {process.env.NODE_ENV !== 'production' && error?.message && (
                        <pre
                            style={{
                                marginTop: 16,
                                textAlign: 'left',
                                fontSize: '0.8rem',
                                whiteSpace: 'pre-wrap',
                                opacity: 0.6,
                            }}
                        >
                            {error.message}
                        </pre>
                    )}
                </div>
            </body>
        </html>
    );
}
